"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configDefaults = void 0;
var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var configDefaults = exports.configDefaults = {
  nui: {
    assets: {
      app: {
        useCDN: {
          value: false
        },
        path: {
          value: '/static'
        }
      },
      cdn: {
        url: {
          value: '//static.concursolutions.com'
        }
      }
    },
    DRCListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    jouleListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    log: {
      application: {
        value: 'appcenter-web',
        useDefault: true
      },
      roletype: {
        value: 'appc',
        useDefault: true
      },
      version: {
        value: '1.0.0',
        useDefault: true
      }
    },
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    categoryDropdownThreshold: {
      value: 20,
      clientExposed: true,
      useDefault: true
    },
    endorsedCategoryEnabled: {
      value: true,
      clientExposed: true,
      useDefault: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    },
    x509: {
      key: {
        value: '',
        useDefault: true
      },
      cert: {
        value: '',
        useDefault: true
      }
    },
    // NUI_ENABLEINCOMPLETEDNFCONNECTIONBLOCKING
    enableIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    // NUI_FORCEINCOMPLETEDNFCONNECTIONBLOCKING
    forceIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://rqa3.nonprod.cnqr.tech',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  },
  cookie_consent: {
    value: false,
    useDefault: true,
    clientExposed: true
  }
};
var _default = exports.default = (0, _nuiConfig.default)(configDefaults);